import {IWSPIconProps, WSPIcon} from '@mintdata-wsp/resources/icons/WSPIcon';
import {PopupAnchor, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {ITooltipProps, Tooltip} from '@mintdata/mint-kit/impl/components/tooltip/Tooltip';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./TopBarButton.less');
const cx = classnames.bind(styles);

export interface ITopBarButtonProps
{
    className?:string;
    iconProps?:IWSPIconProps;
    text?:string;
    textClassName?:string;
    tooltipProps?:ITooltipProps;
    isToggledOn?:boolean;
    onClick?:(event:React.MouseEvent<HTMLElement>) => void;
    onRef?:(ref:HTMLElement) => void
}

@observer
export class TopBarButton extends React.Component<ITopBarButtonProps, any>
{
    public static defaultProps:Partial<ITopBarButtonProps> = {
        isToggledOn: false,
        onRef: () =>
        {
        }
    };

    public render():JSX.Element
    {
        const {
            className,
            iconProps,
            text,
            textClassName,
            tooltipProps,
            isToggledOn,
            onClick,
            onRef,
            ...restProps
        } = this.props;

        const button = (
            <div
                className={cx('base', {isToggledOn}, className)}
                onClick={onClick}
                ref={onRef}
                {...restProps}
            >
                {
                    iconProps &&
                    <WSPIcon
                        className={cx('icon')}
                        {...iconProps}
                        onClick={() =>
                        {
                        }}
                    />
                }
                {
                    text &&
                    <span className={cx('text', textClassName)}>{text}</span>
                }
            </div>
        );

        if( tooltipProps )
        {
            const {popoverProps = {}} = tooltipProps;

            return (
                <Tooltip
                    tooltipClassName={cx('tooltip')}
                    showArrow={false}
                    closeOnTargetClick={true}
                    content={tooltipProps.content}
                    popoverProps={{
                        className: cx('tooltipPopover'),
                        sourceAnchor: SourceAnchor.CenterBottom,
                        popupAnchor: PopupAnchor.CenterTop,
                        ignoreEsc: true,
                        ...popoverProps
                    }}
                >
                    {button}
                </Tooltip>
            );
        }

        return button;
    }
}

